module.exports = "/static/Images/es/survey_no.png";